// Customizable Area Start
import React, { Component } from "react";
import { Box, Grid, Hidden, styled } from "@mui/material";
const LayoutRightBanner = require("./assets/LayoutRightBanner.png");
const LayoutBackBanner = require("./assets/LayoutBackBanner.png");

const BackgroundOverlay = styled(Box)({
  position: "absolute",
  opacity: 0.4,
  inset: 1,
  backgroundColor: "#0F172A",
});

const MainWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "backgroundImg",
})<{ backgroundImg: string }>(({ theme, backgroundImg }) => ({
  flex: 1,
  position: "relative",
  backgroundColor: "#EFF6FF",
  [theme.breakpoints.down("md")]: {
    background: `url(${backgroundImg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
}));

const ContentWrapper = styled(Box)({
  display: "flex",
  justifyContent: "center",
  width: "100%",
  height: "100%",
  padding: "50px 25px",
});

const InnerWrapper = styled(Box)({
  backgroundColor: "#fff",
  borderRadius: "20px",
  padding: "50px",
  maxWidth: "500px",
  width: "100%",
  minHeight: "600px",
  zIndex: 999,
  '@media (max-width: 768px)': {
    padding: "40px"
  },
  '@media (max-width: 414px)': {
    padding: "30px"
  },
});

const BannerWrapper = styled(Box)({
  width: "100%",
  height: "100%",
  overflow: "hidden",
});

const RightBannerImage = styled("img")({
  width: "100%",
  marginTop: "-50px",
});

interface IProps {
  children: React.ReactNode;
}

class CustomPageLayout extends Component<IProps> {
  render() {
    const { children } = this.props;
    return (
      <MainWrapper backgroundImg={LayoutBackBanner}>
        <Hidden mdUp>
          <BackgroundOverlay />
        </Hidden>
        <Grid container>
          <Grid item xs={12} md={7} lg={8} xl={9}>
            <ContentWrapper>
              <InnerWrapper>{children}</InnerWrapper>
            </ContentWrapper>
          </Grid>
          <Hidden mdDown>
            <Grid item xs={0} md={5} lg={4} xl={3}>
              <BannerWrapper>
                <RightBannerImage src={LayoutRightBanner} alt="Banner" />
              </BannerWrapper>
            </Grid>
          </Hidden>
        </Grid>
      </MainWrapper>
    );
  }
}

export default CustomPageLayout;
// Customizable Area End
